import { render, staticRenderFns } from "./provinceReport.vue?vue&type=template&id=62b9be52&scoped=true"
import script from "./provinceReport.vue?vue&type=script&lang=js"
export * from "./provinceReport.vue?vue&type=script&lang=js"
import style0 from "./provinceReport.vue?vue&type=style&index=0&id=62b9be52&prod&scoped=true&lang=css"
import style1 from "./provinceReport.vue?vue&type=style&index=1&id=62b9be52&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62b9be52",
  null
  
)

export default component.exports